import React, { FC } from "react";

import { useParams } from "react-router-dom";

import { EntityType } from "@mapmycustomers/shared/enum";

import FilePreviewPage from "@app/component/FilePreviewPage";

export interface FilesPageProps {}

const FilePage: FC<FilesPageProps> = () => {
  const { aid, fileId } = useParams<{ aid: string; fileId: string }>();
  return (
    <FilePreviewPage
      entityId={parseInt(aid, 10)}
      entityType={EntityType.ACTIVITY}
      fileId={parseInt(fileId, 10)}
    />
  );
};

export default FilePage;
